<template>
  <template v-for="(route, idx) in items">
    <va-dropdown
      v-if="route.meta.roles[0] === '*' || route.meta.roles.includes(userRole)"
      :key="idx"
      v-model="dropdownsValue[idx]"
      placement="right-start"
      prevent-overflow
      :offset="[1, 0]"
    >
      <template #anchor>
        <va-sidebar-item :active="isItemChildsActive(route)" :to="route.children ? undefined : { name: route.name }">
          <va-sidebar-item-content>
            <va-icon :name="route.meta.icon" class="va-sidebar-item__icon text-white" />
            <span
              v-if="shouldShowApplicationsBadge(route)"
              class="absolute top-1 right-1 rounded-full px-1.5 py-0.5 text-[10px] font-semibold text-black"
              style="background-color: #f9ad22"
            >
              {{ pendingApplicationsCount }}
            </span>
            <va-icon
              v-if="route.children"
              class="more_icon text-white"
              :name="dropdownsValue[idx] ? 'chevron_left' : 'chevron_right'"
            />
          </va-sidebar-item-content>
        </va-sidebar-item>
      </template>
      <div class="sidebar-item__children">
        <template v-for="(child, index) in route.children" :key="index">
          <va-sidebar-item :active="isRouteActive(child)" :to="{ name: child.name }">
            <va-sidebar-item-content>
              <va-sidebar-item-title>
                {{ t(child.displayName) }}
              </va-sidebar-item-title>
            </va-sidebar-item-content>
          </va-sidebar-item>
        </template>
      </div>
    </va-dropdown>
  </template>
</template>

<script setup lang="ts">
  import { INavigationRoute } from '../NavigationRoutes'
  import { ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import { useGlobalStore } from '@/stores/global-store'
  import { storeToRefs } from 'pinia'
  const { t } = useI18n()

  const props = withDefaults(
    defineProps<{
      items?: INavigationRoute[]
      pendingApplicationsCount?: number
    }>(),
    {
      items: () => [],
      pendingApplicationsCount: 0,
    },
  )

  const dropdownsValue = ref([])

  // function isGroup(item: INavigationRoute) {
  //   return !!item.children
  // }

  function isRouteActive(item: INavigationRoute) {
    const route = useRoute()
    if (item.name !== route.name) return false
    if (!item.query) return true
    return JSON.stringify(item.query) === JSON.stringify(route.query)
  }

  function isItemChildsActive(item: INavigationRoute): boolean {
    if (!item.children) {
      return false
    }

    const isCurrentItemActive = isRouteActive(item)

    let isChildActive = false
    if (item.children) {
      isChildActive = !!item.children.find((child) =>
        child.children ? isItemChildsActive(child) : isRouteActive(child),
      )
    }

    return isCurrentItemActive || isChildActive
  }

  const globalStore = useGlobalStore()
  const { userRole } = storeToRefs(globalStore)

  const shouldShowApplicationsBadge = (route: INavigationRoute) => {
    return (
      userRole.value === 'business_partner' && route.name === 'drivers' && (props.pendingApplicationsCount || 0) > 0
    )
  }
</script>

<style lang="scss">
  .sidebar-item {
    &__children {
      max-height: 60vh;
      overflow-y: auto;
      overflow-x: visible;
      width: 16rem;
      color: var(--va-gray);
      background: var(--va-white, #fff);
      box-shadow: var(--va-box-shadow);
    }
  }

  .va-sidebar-item {
    &-content {
      position: relative;

      .more_icon {
        text-align: center;
        position: absolute;
        bottom: 0.5rem;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
</style>
